
(() => {
  const KEY = 'sa_subscription_popup_v1';

  const read = () => {
    try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {}; }
    catch (_) { return {}; }
  };
  const write = (patch) => {
    try { localStorage.setItem(KEY, JSON.stringify({ ...read(), ...patch })); }
    catch (_) {  }
  };

  const el = document.querySelector('[data-subscription-popup]');
  if (!el) return;

  const cartPage = /\/cart(\/|$|\?)/.test(location.pathname + location.search);
  const drawerOpen = () => {
    const d = document.querySelector('cart-drawer');
    if (!d) return false;
    if (d.classList.contains('is-open')) return true;
    return d.getAttribute('aria-hidden') === 'false';
  };

  const scrollNeed = Number(el.dataset.scroll) || 60;
  const timerNeed = Number(el.dataset.timer) || 40000;
  const reopenAfter = Number(el.dataset.reopenAfter) || 600000;
  const graceNeed = Number(el.dataset.grace) || 0;
  const path = location.pathname;

  let opened = false;
  let timer = null;
  let clearedAt = 0;
  let waiting = null;      

  const CONSENT = '#shopify-pc__banner, #shopify-pc__prefs, cookie-consent';

  function shown(node) {
    if (!node) return false;

    if (node.checkVisibility) return node.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true });
    const r = node.getBoundingClientRect();
    const st = getComputedStyle(node);
    return r.width > 0 && r.height > 0 && st.display !== 'none' && st.visibility !== 'hidden';
  }

  const consentOnScreen = () => [...document.querySelectorAll(CONSENT)].some(shown);

  function blocked() { return cartPage || drawerOpen(); }

  function trigger() {
    if (opened || waiting) return;
    clearTimeout(timer);
    window.removeEventListener('scroll', onScroll);
    if (!consentOnScreen() && !blocked()) { open(); return; }

    waiting = setInterval(() => {

      if (consentOnScreen() || blocked()) { clearedAt = 0; return; }
      if (!clearedAt) clearedAt = Date.now();
      if (Date.now() - clearedAt < graceNeed) return;
      clearInterval(waiting);
      waiting = null;
      open();
    }, 500);
  }

  function open() {
    if (opened) return;
    opened = true;
    clearTimeout(timer);
    if (waiting) { clearInterval(waiting); waiting = null; }
    window.removeEventListener('scroll', onScroll);
    el.hidden = false;

    requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('is-open')));
    document.body.classList.add('subscription-popup-open');
    el.querySelector('input:not([type=hidden])')?.focus({ preventScroll: true });
    document.addEventListener('keydown', onKey);
  }

  function close() {
    el.classList.remove('is-open');
    document.body.classList.remove('subscription-popup-open');
    document.removeEventListener('keydown', onKey);

    setTimeout(() => { el.hidden = true; }, 250);
    write({ closedAt: Date.now(), closedPath: path });
  }

  const onKey = (e) => { if (e.key === 'Escape') close(); };

  function onScroll() {
    const h = document.documentElement.scrollHeight - window.innerHeight;

    if (h <= 0) return;
    if ((window.scrollY / h) * 100 >= scrollNeed) trigger();
  }

  el.addEventListener('click', (e) => {
    if (e.target.closest('[data-subscription-close]')) { e.preventDefault(); close(); }
  });

  if (el.hasAttribute('data-open-success')) {
    write({ subscribed: true });
    trigger();
    return;
  }

  const st = read();
  if (st.subscribed) return;

  if (st.closedAt) {
    const waited = Date.now() - st.closedAt >= reopenAfter;
    const moved = st.closedPath !== path;
    if (!waited || !moved) return;
  }

  timer = setTimeout(trigger, timerNeed);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();   
})();
